<div class="ml-[-14px]">
  <mat-list *ngIf="filteredAttachments.length > 0">
    <mat-list-item *ngFor="let attachment of filteredAttachments">
      <div class="flex  items-start">
        <img
        [src]="getFileIcon(attachment)"
        alt="File Icon"
        class="mr-2 w-6 h-6"
      />
        <a
          (click)="downloadFile(attachment.id, attachment[config.fileNameKey])"
          target="_blank"
          style="cursor: pointer; text-decoration: underline; color: #343A40"
        >
          {{ attachment[config.fileNameKey] }}
        </a>
      </div>
    </mat-list-item>
  </mat-list>
</div>
<p *ngIf="filteredAttachments.length === 0">No attachments available.</p>
